// Shared, non-component helpers for the display-config preview. Kept out of
// ``display-preview-dialog.tsx`` so that file only exports components (React
// Fast Refresh requirement).

// The registration lifecycle workflow whose state drives the ``status``
// column - mirrors the constant used on the registrations list + record
// pages so the preview resolves status identically.
export const STATUS_WORKFLOW_KEY = 'lifecycle_status'

/** A configured value counts as resolved when it is not null/undefined/empty. */
export function isResolvedDisplayValue(value: unknown) {
  return value !== null && value !== undefined && value !== ''
}
